/* mintbrick – Buehne: Noppenfeld auf Canvas mit wanderndem Streiflicht. */
(function () {
  'use strict';
  var canvases = document.querySelectorAll('[data-bk-stage]');
  if (!canvases.length) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Eine Noppe einmal vorzeichnen, danach nur noch kopieren.
  function studSprite(size, dpr) {
    var s = document.createElement('canvas');
    var px = Math.ceil(size * dpr);
    s.width = px; s.height = px;
    var c = s.getContext('2d'), r = px / 2;
    var body = c.createRadialGradient(r * 0.66, r * 0.6, r * 0.06, r, r, r);
    body.addColorStop(0, 'rgba(238,255,246,0.95)');
    body.addColorStop(0.42, 'rgba(159,227,193,0.62)');
    body.addColorStop(1, 'rgba(40,96,74,0.04)');
    c.fillStyle = body;
    c.beginPath(); c.arc(r, r, r * 0.86, 0, Math.PI * 2); c.fill();
    c.globalCompositeOperation = 'multiply';
    var sh = c.createLinearGradient(0, 0, px, px);
    sh.addColorStop(0, 'rgba(255,255,255,0)');
    sh.addColorStop(1, 'rgba(3,10,7,0.55)');
    c.fillStyle = sh;
    c.beginPath(); c.arc(r, r, r * 0.86, 0, Math.PI * 2); c.fill();
    return s;
  }

  function mount(canvas) {
    var ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;
    var STEP = parseInt(canvas.dataset.step, 10) || 44;
    var STUD = STEP * 0.6;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var sprite = studSprite(STUD, dpr);
    var w = 0, h = 0, cols = 0, rows = 0, t = 0, raf = null, visible = true;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      w = Math.max(1, rect.width); h = Math.max(1, rect.height);
      canvas.width = Math.ceil(w * dpr); canvas.height = Math.ceil(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(w / STEP) + 2; rows = Math.ceil(h / STEP) + 2;
    }

    function draw() {
      ctx.clearRect(0, 0, w, h);
      // Licht kreist ueber der rechten Haelfte, wo kein Text steht.
      var lx = w * (0.72 + 0.2 * Math.sin(t * 0.00012));
      var ly = h * (0.36 + 0.18 * Math.sin(t * 0.00019 + 1.1));
      var reach = Math.max(w, h) * 0.58;
      var ox = (t * 0.004) % STEP;
      var oy = Math.sin(t * 0.00009) * STEP * 0.5;
      for (var r = 0; r < rows; r++) {
        var stagger = (r % 2) * (STEP / 2);
        var y = r * STEP - STEP + oy;
        for (var c = 0; c < cols; c++) {
          var x = c * STEP - STEP + stagger + ox;
          var dx = x - lx, dy = y - ly;
          var lit = Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) / reach);
          var a = 0.03 + Math.pow(lit, 2.4) * 0.55;
          if (a < 0.02) continue;
          ctx.globalAlpha = a;
          ctx.drawImage(sprite, x - STUD / 2, y - STUD / 2, STUD, STUD);
        }
      }
      ctx.globalAlpha = 1;
    }

    var last = 0;
    function loop(now) {
      raf = window.requestAnimationFrame(loop);
      if (!visible || now - last < 33) return;
      last = now; t = now; draw();
    }

    resize(); draw();
    if (!reduced) {
      raf = window.requestAnimationFrame(loop);
      if ('IntersectionObserver' in window) {
        new window.IntersectionObserver(function (e) { visible = e[0].isIntersecting; }, { threshold: 0 }).observe(canvas);
      }
    }
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        sprite = studSprite(STUD, dpr); resize(); draw();
      }, 160);
    });
    var guard = setInterval(function () {
      if (!document.contains(canvas)) { if (raf) window.cancelAnimationFrame(raf); clearInterval(guard); }
    }, 2000);
  }

  Array.prototype.forEach.call(canvases, mount);
})();
